import {
  ApplicationConfig,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { CommonModule } from '@angular/common';
import { jwtInterceptor } from './core/interceptors/jwt/jwt.interceptor';
import { errorInterceptor } from './core/interceptors/error/error.interceptor';
import { loaderInterceptor } from './core/interceptors/loader/loader.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  LoggerService,
  LogLevel,
  LogLevelToken,
} from '@sharedModule/components/logger/service/logger.service';
import { loggerInterceptor } from '@core/interceptors/logger/logger.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        jwtInterceptor,
        errorInterceptor,
        loaderInterceptor,
        
      ])
    ),
    CommonModule,
    provideAnimations(),
    provideAnimationsAsync(),
    {
      provide: LoggerService,
      useClass: LoggerService,
    },
    {
      provide: LogLevelToken,
      useValue: isDevMode() ? LogLevel.Info : LogLevel.None,
    },
  ],
};
